'use client';

import { MinusSign } from '@/assets/icons/Minus';
import { PlusSign } from '@/assets/icons/Plus';
import { ComponentFaqProps } from '@/types/components';
import { useState } from 'react';

export function Faq(props: ComponentFaqProps) {
  const { id, question, answer } = props;
  const [showAnswer, setShowAnswer] = useState(false);

  const handleClick = () => setShowAnswer(prev => !prev);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const answerId = `faq-answer-${id}`;

  const styles = {
    container:
      'border-sh-black w-full space-y-5 border-t-1 py-5 last:pb-0 md:py-10 text-left select-none',
    button: 'w-full cursor-pointer',
    question: 'flex items-center justify-between space-x-5 w-full',
    questionHeading: 'sh-body font-sans font-bold',
    answerContainer: '',
    answer: 'sh-body prose prose-neutral max-w-none',
    toggleIcon: 'flex flex-col items-center',
  };

  return (
    <div className={styles.container}>
      <h3>
        <button
          className={styles.button}
          data-test='faq'
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          aria-expanded={showAnswer}
          aria-controls={answerId}
          type='button'
        >
          <div data-test='faq-question' className={styles.question}>
            <span
              data-test='faq-question-heading'
              className={styles.questionHeading}
            >
              {question}
            </span>
            <div
              className={styles.toggleIcon}
              data-test='faq-showAnswer-icon'
              aria-hidden='true'
            >
              {showAnswer ? (
                <MinusSign className='size-6 md:size-8' />
              ) : (
                <PlusSign className='size-6 md:size-8' />
              )}
            </div>
          </div>
        </button>
      </h3>
      {showAnswer && (
        <div
          className={styles.answerContainer}
          id={answerId}
          role='region'
          aria-labelledby={`faq-question-${id}`}
        >
          <div
            data-test='faq-answer'
            className={styles.answer}
            dangerouslySetInnerHTML={{ __html: answer || '' }}
          />
        </div>
      )}
    </div>
  );
}
